import React from "react";
import {
  Box,
  Typography,
  Grid,
  Container
} from "@mui/material";

import dylan from "../../images/dylan-stony-brook.jpg"
import alyse from "../../images/alyse.jpg"



export default function Header() {
  return (
    <Box sx={{ bgcolor: "#f4f7fb", color: "#001a3d", py: { xs: 0, md: 0 } }}>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
        //   minHeight: "100vh",
          height: {xl: "900px", lg: "800px", md: "700px", sm: "600px", xs: "600px"},
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
          }}
        >
          <Box
            sx={{
              flex: 1,
              backgroundImage: `linear-gradient(120deg, rgba(0, 0, 31, 0.55) 0%, rgba(226, 29, 43, 0.25) 100%), url(${dylan})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
          <Box
            sx={{
              flex: 1,
              backgroundImage: `linear-gradient(120deg, rgba(0, 0, 31, 0.4) 0%, rgba(226, 29, 43, 0.3) 100%), url(${alyse})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
        </Box>

        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1, py: { xs: 6, md: 8 }, display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100%" }}>
          <Box
            sx={{
              mx: "auto",
              maxWidth: 760,
              mt: { xs: 12, sm: 0 },
              px: { xs: 2, sm: 3 },
              py: { xs: 3, sm: 4 },
              textAlign: "center",
              background: "rgba(0, 17, 31, 0.18)",
              backdropFilter: {sm: "blur(2px)"},
              borderRadius: 3,
            }}
          >
            <Typography
              variant="h1"
              gutterBottom
              sx={{
                color: "#ffffff",
                textShadow: "0 2px 12px rgba(0,0,0,0.38)",
                fontSize: { xs: "32px", sm: "40px", lg: "60px" },
                lineHeight: 1.1,
                letterSpacing: "-0.04em",
                mb: 2,
              }}
            >
              Pathway to College Soccer
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: "#edf4ff",
                textShadow: "0 2px 8px rgba(0,0,0,0.3)",
                opacity: 0.97,
                lineHeight: { xs: 1.5, sm: 1.7 },
                maxWidth: 620,
                mx: "auto",
                fontSize: { xs: "13px", md: "25px"},
              }}
            >
              Our graduates consistently earn roster spots at elite NCAA programs and beyond. With dedicated recruiting support, showcase exposure, and relationships nationwide, Atlantic United players take the next step prepared and confident.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
